module.exports = __webpack_public_path__ + "assets/images/cockpit/cockpit_dark.png";